import { ApiResponse, Service } from "@roc/feature-app-core";

export class InsuranceCarrierService extends Service {
  getInsuranceCarrierGrid(page: number, pageSize: number, sortDir: string, sortBy: string, filters: object): Promise<ApiResponse> {
    return this.get('/api/v1/doc-review/insurance/getInsuranceCarrierGrid', { page, pageSize, sortDir, sortBy, filters });
  }
  getInsuranceCarrierOptions(): Promise<ApiResponse> {
    return this.get('/api/v1/doc-review/insurance/getInsuranceCarrierOptions');
  }
  saveCarrier(record: any): Promise<ApiResponse> {
    return this.post('/api/v1/doc-review/insurance/saveCarrier', record);
  }

  deleteCarrier(insuranceCarrierId: number): Promise<ApiResponse> {
    return this.get('/api/v1/doc-review/insurance/deleteCarrier', { insuranceCarrierId });
  }
}